import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import moment from 'moment';

import { constants } from '../../config';
import { ConfigParametersStore } from '../../stores/ConfigParametersStore';
import { goToPage, routeNaming } from '../../routes';
import { IncrementalCheckoutSummary } from '../../common/incremental-checkout-summary';
import { InstallationForm } from '../../common/installation-form';
import { SecondaryButton } from '../../common/secondary-button';
import { SimpleButton } from '../../common/simple-button';
import { Modal } from '../../common/modal';
import { ScreenStore } from '../../stores/ScreenStore';
import { CheckoutStore } from '../../stores/CheckoutStore';
import { CartStore } from '../../stores/CartStore';
import styles from './InstallationOptions.css';

const IPropTypes = {
  onSubmit: PropTypes.func,
};

const defaultProps = {
  onSubmit: () => {},
};

class InstallationOptions extends React.Component {
  static async removeInstallations() {
    await CartStore.removeInstallationsFromCart();
    goToPage(routeNaming.CART);
  }

  static cancelCheckout() {
    goToPage(routeNaming.CART);
  }

  constructor(props) {
    super(props);
    this.state = {
      invalidAddress: false,
      invalidAddressMessage: '',
    };

    this._onInvalidAddress = this._onInvalidAddress.bind(this);
  }

  _onInvalidAddress(error) {
    this.setState({
      invalidAddress: true,
      invalidAddressMessage: error.message,
    });
  }

  render() {
    let startDate = null;
    if (CheckoutStore.selectedTimeSlot) {
      startDate = CheckoutStore.selectedTimeSlot.date.toJSDate();
    } else {
      startDate = CheckoutStore.selectedOption.date.toJSDate();
    }

    startDate = moment(startDate);
    startDate.add(1, 'd');

    if (moment(ConfigParametersStore.parameters.installationDate) >= startDate) {
      startDate = ConfigParametersStore.parameters.installationDate;
    }

    return (
      <div className={styles.container}>
        <h1 className={styles.title}>
          Opciones de envío: Servicios
        </h1>
        <div className={styles.mainContent}>
          <div className={styles.optionSection}>
            <InstallationForm
              cart={CheckoutStore.checkoutCart}
              addressId={CheckoutStore.selectedAddress.id}
              onSubmit={this.props.onSubmit}
              onInvalidAddress={this._onInvalidAddress}
              startDate={startDate}
            />
          </div>
          {
            ScreenStore.screenWidth > constants.breakpoints.smallMaxWidth &&
            <div className={styles.summarySection}>
              <IncrementalCheckoutSummary />
            </div>
          }
        </div>
        {
          this.state.invalidAddress &&
          <Modal>
            <div className={styles.modalContainer}>
              <p className={styles.modalText}>
                {this.state.invalidAddressMessage}
              </p>
              <div className={styles.buttonContainer}>
                <SecondaryButton
                  className={styles.button}
                  onClick={InstallationOptions.removeInstallations}
                >
                  Eliminar instalaciones
                </SecondaryButton>
                <SimpleButton
                  className={styles.button}
                  onClick={InstallationOptions.cancelCheckout}
                >
                  Cancelar Pedido
                </SimpleButton>
              </div>
            </div>
          </Modal>
        }
      </div>
    );
  }
}

InstallationOptions.propTypes = IPropTypes;
InstallationOptions.defaultProps = defaultProps;

const ObservedInstallationOptions = observer(InstallationOptions);

export { ObservedInstallationOptions as InstallationOptions };



// WEBPACK FOOTER //
// ./src/pages/installation-options/InstallationOptions.jsx